import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Rocket, Check, Mail, CalendarCheck, MapPin, Target } from "lucide-react";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";

const STEPS = [
  { key: "email_connected", title: "Connect work email", hint: "Google or Outlook — pick one", cta: "Connect email", to: "/app/settings/integrations", icon: Mail },
  { key: "booking_ready", title: "Add booking link", hint: "Where prospects grab time", cta: "Add booking URL", to: "/app/settings/integrations", icon: CalendarCheck },
  { key: "address_set", title: "Mailing address", hint: "Shown in every send footer", cta: "Add address", to: "/app/admin/sending", icon: MapPin },
  { key: "offer_created", title: "Create your offer", hint: "What you sell, and to whom", cta: "Create offer", to: "/app/offer", icon: Target },
];

export function SetupStrip() {
  const [s, setS] = useState(null);
  const navigate = useNavigate();
  useEffect(() => { api.get("/setup/status").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s || s.complete) return null;
  const manual = s.manual_send;

  return (
    <div className="rounded-xl border border-amber-500/30 bg-amber-500/5 p-5 mb-6" data-testid="setup-strip">
      <div className="flex items-center gap-2 mb-4">
        <Rocket className="h-4 w-4 text-amber-500" />
        <span className="text-sm font-medium">{manual ? "Finish setup — send by hand until you connect a mailbox" : "Finish setup to send your first live email"}</span>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {STEPS.map((st) => {
          const done = s[st.key];
          const optional = manual && st.key === "email_connected";
          const title = optional ? "Connect work email (optional) — or send by hand" : st.title;
          const tag = optional ? "Optional" : (manual && (st.key === "booking_ready" || st.key === "address_set") ? "Recommended" : null);
          return (
            <div key={st.key} className={`rounded-lg border p-4 flex flex-col ${done ? "border-emerald-500/30 bg-emerald-500/5" : "border-border/60 bg-card/40"}`} data-testid={`setup-step-${st.key}`}>
              <div className="flex items-center gap-2 mb-1">
                {done
                  ? <span className="h-5 w-5 rounded-full bg-emerald-500/15 text-emerald-500 flex items-center justify-center shrink-0"><Check className="h-3 w-3" /></span>
                  : <st.icon className="h-4 w-4 text-amber-500 shrink-0" />}
                <span className="text-sm font-medium">{title}</span>
              </div>
              <p className="text-xs text-muted-foreground flex-1">{st.hint}{tag ? ` · ${tag}` : ""}</p>
              <div className="mt-3">
                {done
                  ? <span className="text-xs text-emerald-500 font-medium">Done</span>
                  : <Button size="sm" className="rounded-md bg-amber-500 text-black hover:bg-amber-400 w-full" onClick={() => navigate(st.to)} data-testid={`setup-btn-${st.key}`}>{st.cta}</Button>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
